import React, { useState } from "react";
import "../css/pages/contentShow.scss";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SmallContentDisplay from "../pages/components/SmallContentDisplay";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import Sidebar from "../pages/components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import imageUrl from "../assets/contentMedia/posts/1.webp";
import { withErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../helpers/ErrorFallback";
import { useGetPosts, useGetGalleries } from "../queries";
import { LoadingIndicator } from "../pages/components/loadingIndicator";

export interface iContent {
  title: string;
  postText: string;
  previewText: string;
  date: string;
  id: number;
  coverImage: string;
}

export interface iImageContent {
  id: number;
  path: string;
  PostId?: number;
  GalleryId?: number;
}

interface Props {
  category: string;
}

type StatusKey = keyof iImageContent;

const ContentShowReactQuery: React.FC<Props> = (Props) => {
  const history = useNavigate();

  // React Query hooks instead of Redux useSelector
  const { data: posts = [], isLoading: postsLoading } = useGetPosts();
  const { data: galleries = [], isLoading: galleriesLoading } =
    useGetGalleries();

  const relatedContents = Props.category === "posts" ? posts : galleries;
  const isLoading =
    Props.category === "posts" ? postsLoading : galleriesLoading;

  let contentShowNumbersStep = 5;
  const [contentShowNumbers, setContentShowNumbers] = useState(
    contentShowNumbersStep
  );

  const handleLoadMoreOrLess = () => {
    if (contentShowNumbers === relatedContents.length) {
      setContentShowNumbers(contentShowNumbersStep);
    } else {
      setContentShowNumbers(relatedContents.length);
    }
  };

  const handleReadMore = (id: number) => {
    history(`/${Props.category}/${id}`);
  };

  // Show loading state while data is being fetched
  if (isLoading) {
    return (
      <div className="mainPanel">
        <div className="contentShowPanelMain">
          <LoadingIndicator />
        </div>
      </div>
    );
  }

  return (
    <div className="mainPanel">
      <div className="contentShowPanelMain">
        <SmallContentDisplay
          category={Props.category === "posts" ? "posts" : "gallery"}
        />
        <div className="listOfContentsWithImage">
          {relatedContents
            ?.slice(0, contentShowNumbers)
            .map((value: iContent) => (
              <div key={value.id} className="contentContainer">
                <div className="contentImageContainer">
                  <img
                    src={require(`../${value.coverImage}`)}
                    alt="content pic"
                    className="contentImage"
                  />
                </div>
                <div className="contentTextContainer">
                  <div className="contentTitle">{value.title}</div>
                  <div
                    className="contentText"
                    dangerouslySetInnerHTML={{ __html: value.previewText }}
                  />
                  <div className="contentDateAuthor">
                    <div className="contentDate">
                      <AccessTimeIcon className="dateIcon" />
                      {value.date}
                    </div>
                    <div className="contentAuthor">
                      <AccountCircleIcon className="authorIcon" />
                      نویسنده
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    className="readMoreButton"
                    onClick={() => handleReadMore(value.id)}
                  >
                    ادامه مطلب
                  </Button>
                </div>
              </div>
            ))}
        </div>
        {relatedContents?.length > contentShowNumbersStep && (
          <div className="loadMoreContainer">
            <Button
              variant="outlined"
              className="loadMoreButton"
              onClick={handleLoadMoreOrLess}
            >
              {contentShowNumbers === relatedContents.length
                ? "نمایش کمتر"
                : "نمایش بیشتر"}
            </Button>
          </div>
        )}
        <Sidebar category={Props.category} />
      </div>
    </div>
  );
};

export default withErrorBoundary(ContentShowReactQuery, {
  FallbackComponent: ErrorFallback,
});
